<template>
  <WdsStack gap-sm direction-column>
    <WdsSelect
      v-model="selectedClassificationUsage"
      multi-select
      searchable
      :label="meta.filter.quickFilter ? '' : $t('Using Worksome Classify')"
      :list="classificationUsageOptions"
      :placeholder="$t('Select')"
      can-deselect
      labels-primary
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack } from '@worksome/wds-components'
import { computed, ModelRef } from 'vue'
import { $t } from '@/composables/translation'
import { ClassificationUsage } from '@/gql/graphql'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

defineProps<{ meta: FilterMetaDataProp }>()

const selectedClassificationUsage: ModelRef<string[]> = defineModel({
  default: () => [],
})

const orderedClassificationUsages = [
  { label: $t('Yes'), value: ClassificationUsage.Using },
  { label: $t('Overridden'), value: ClassificationUsage.UsingWithOverride },
  { label: $t('No'), value: ClassificationUsage.NotUsing },
]

const classificationUsageOptions = computed(() =>
  orderedClassificationUsages.map((usage) => ({
    label: usage.label,
    value: usage.value,
  })),
)
</script>
